<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  watch: {
    '$store.state.isMedicalAssociationEnv': {
      handler(newVal) {
        console.log('newVal', newVal)
        const color = newVal ? 'rgba(229, 56, 41, 1)' : '#4054af'
        document.documentElement.style.setProperty('--primary-color', color)
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">
html,
body {
  height: 100%;
}
#app {
  text-align: center;
  color: #2c3e50;
}
</style>
